import * as React from "react";
import { UitkLayoutFlexItem } from "../uitk-react-layout-flex/index.js";
import { classNames } from "../uitk-react-utils/index.js";
export class UitkToolbarContent extends React.Component {
  static displayName = "UitkToolbarContent";
  render() {
    const { className, children, grow, minWidth } = this.props;
    return /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, { className: classNames(className), grow, minWidth }, /* @__PURE__ */ React.createElement("section", null, children));
  }
}
